// Screen: connessione persa, retry automatico ogni 3s fino a 5 tentativi.

import { icon } from './icons.js';

export interface LostProps { signaling: unknown; }
interface Callbacks {
  onRecovered: () => void;
  onGiveUp: () => void;
}

export async function mountConnectionLost(root: HTMLElement, _props: LostProps, cb: Callbacks): Promise<void> {
  root.innerHTML = `
    <div class="lost-screen">
      <div class="lost-card">
        <div class="lost-icon">${icon('wifi-off', 'icon icon-lg')}</div>
        <h1>Connessione persa</h1>
        <p>Non siamo più in contatto con il server della riunione.</p>
        <div class="lost-retry">
          <span class="spinner-ring"></span>
          <span id="retry-msg">Riprovo automaticamente…</span>
        </div>
        <div class="lost-actions">
          <button class="btn-gold" id="retry-now">${icon('refresh', 'icon icon-sm')} Riprova ora</button>
          <button class="btn-ghost-dark" id="back-lobby">${icon('chevron-left', 'icon icon-sm')} Torna alla lobby</button>
        </div>
      </div>
    </div>
  `;
  const msg = root.querySelector<HTMLElement>('#retry-msg')!;
  root.querySelector<HTMLButtonElement>('#back-lobby')!.addEventListener('click', () => cb.onGiveUp());
  root.querySelector<HTMLButtonElement>('#retry-now')!.addEventListener('click', () => {
    location.reload();
  });
  let attempts = 0;
  const maxAttempts = 5;
  const interval = setInterval(() => {
    attempts++;
    msg.textContent = `Tentativo ${attempts}/${maxAttempts}…`;
    if (attempts >= maxAttempts) {
      clearInterval(interval);
      msg.textContent = 'Riprova manualmente o torna alla lobby.';
      return;
    }
    // semplice retry: reload pagina (mantiene #fragment col token)
    if (attempts === maxAttempts - 1) location.reload();
  }, 3000);
}
